import { useMemo, useState } from 'react';
import { BANNER_ADS } from '../parody-data.js';
import { FACELEAK_NAV_LINKS, FACELEAK_PROFILES } from '../../data/faceleakProfiles.js';

export const MyFacePage = ({ onNavigate }) => {
  const [currentProfileId, setCurrentProfileId] = useState(FACELEAK_PROFILES[0].id);

  const currentProfile = useMemo(
    () => FACELEAK_PROFILES.find((profile) => profile.id === currentProfileId) || FACELEAK_PROFILES[0],
    [currentProfileId]
  );

  const profilesById = useMemo(
    () => FACELEAK_PROFILES.reduce((acc, profile) => {
      acc[profile.id] = profile;
      return acc;
    }, {}),
    []
  );

  const randomAd = useMemo(
    () => BANNER_ADS[Math.floor(Math.random() * BANNER_ADS.length)],
    []
  );

  const openVideo = (youtubeId) => {
    onNavigate('youtoob', { initialVideoId: youtubeId, autoPlayInitial: true });
  };

  return (
    <div className="myface-page" data-testid="myface-page">
      <div className="myface-header">
        <div className="myface-brand-row">
          <button type="button" className="myface-logo" onClick={() => onNavigate('portal')}>
            <span className="logo-my">Face</span>
            <span className="logo-face">Leak</span>
          </button>
          <div className="myface-header-links">
            <a href="#" onClick={(e) => e.preventDefault()}>My Profile</a>
            <a href="#" onClick={(e) => e.preventDefault()}>Edit Profile</a>
            <a href="#" onClick={(e) => e.preventDefault()}>Account Settings</a>
            <a href="#" onClick={(e) => e.preventDefault()}>Sign Out</a>
          </div>
        </div>

        <div className="myface-nav">
          {FACELEAK_NAV_LINKS.map((item) => (
            <a key={item} href="#" onClick={(e) => e.preventDefault()}>{item}</a>
          ))}
        </div>

        <div className="myface-search">
          <label htmlFor="faceleak-search">Search:</label>
          <input id="faceleak-search" type="text" defaultValue="people, schools, networks" />
          <button type="button">Go</button>
        </div>
      </div>

      <div className="myface-banner">
        <marquee className="ad-marquee" scrollamount="4" style={{ backgroundColor: randomAd.color }}>
          {randomAd.text} | {randomAd.subtext} | Sponsored Listing
        </marquee>
      </div>

      <div className="myface-profile-switcher" data-testid="faceleak-profile-switcher">
        <span className="switcher-label">View Profiles:</span>
        {FACELEAK_PROFILES.map((profile) => (
          <button
            key={profile.id}
            type="button"
            className={profile.id === currentProfile.id ? 'active' : ''}
            onClick={() => setCurrentProfileId(profile.id)}
          >
            {profile.name}
          </button>
        ))}
      </div>

      <div className="myface-content">
        <div className="profile-left">
          <div className="profile-module profile-identity">
            <h3>{currentProfile.name}</h3>
            <div className="profile-avatar-wrap">
              <img
                src={currentProfile.avatar}
                alt={`${currentProfile.name} avatar`}
                className="profile-avatar"
              />
            </div>
            <p className="profile-status">{currentProfile.status}</p>
            <table className="profile-fact-table">
              <tbody>
                <tr><td>Age:</td><td>{currentProfile.age}</td></tr>
                <tr><td>Location:</td><td>{currentProfile.location}</td></tr>
                <tr><td>Relationship:</td><td>{currentProfile.relationship}</td></tr>
                <tr><td>Occupation:</td><td>{currentProfile.occupation}</td></tr>
                <tr><td>Member Since:</td><td>{currentProfile.memberSince}</td></tr>
                <tr><td>Last Login:</td><td>{currentProfile.lastLogin}</td></tr>
              </tbody>
            </table>
            <div className="profile-counters">
              <span>Friends: {currentProfile.friendCount.toLocaleString()}</span>
              <span>Profile Views: {currentProfile.profileViews.toLocaleString()}</span>
            </div>
          </div>

          <div className="profile-module">
            <h4>Contacting</h4>
            <div className="profile-action-list">
              <button type="button">Add to Friends</button>
              <button type="button">Send Message</button>
              <button type="button">Add to Favorites</button>
              <button type="button">Block User</button>
            </div>
          </div>

          <div className="profile-module">
            <h4>Top Friends</h4>
            <div className="top-friends-list">
              {currentProfile.topFriends.map((friendId) => {
                const friend = profilesById[friendId];
                if (!friend) return null;
                return (
                  <button
                    type="button"
                    key={friend.id}
                    className="top-friend-item"
                    onClick={() => setCurrentProfileId(friend.id)}
                  >
                    <img src={friend.avatar} alt={`${friend.name} avatar`} />
                    <span>{friend.name}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="profile-module">
            <h4>Networks</h4>
            <ul className="module-list">
              <li>{currentProfile.network}</li>
              <li>FaceLeak Music Board</li>
              <li>Regional Meetups</li>
            </ul>
          </div>
        </div>

        <div className="profile-main">
          <div className="profile-module profile-header-box">
            <h1>{currentProfile.name}</h1>
            <p className="tagline">{currentProfile.tagline}</p>
            <p className="profile-url">http://www.faceleak.com/{currentProfile.handle}</p>
          </div>

          <div className="profile-module">
            <h4>About Me</h4>
            <p>{currentProfile.about}</p>
          </div>

          <div className="profile-module">
            <h4>Interests</h4>
            <table className="interests-table">
              <tbody>
                <tr><td>General</td><td>{currentProfile.interests.general}</td></tr>
                <tr><td>Music</td><td>{currentProfile.interests.music}</td></tr>
                <tr><td>Movies</td><td>{currentProfile.interests.movies}</td></tr>
                <tr><td>Books</td><td>{currentProfile.interests.books}</td></tr>
              </tbody>
            </table>
          </div>

          <div className="profile-module media-module">
            <h4>Favorite Videos</h4>
            <ul className="video-link-list">
              {currentProfile.videos.map((video) => (
                <li key={video.id}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      openVideo(video.youtubeId);
                    }}
                  >
                    {video.title}
                  </a>
                  <span>{video.note}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="profile-module media-module">
            <h4>Wall</h4>
            <div className="wall-posts">
              {currentProfile.wall.map((post) => (
                <div key={post.id} className="wall-post">
                  <div className="wall-post-meta">
                    <a href="#" onClick={(e) => e.preventDefault()}>{post.author}</a>
                    <span>{post.date}</span>
                  </div>
                  <p>{post.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="profile-right">
          <div className="profile-module media-module">
            <h4>Photos</h4>
            <div className="photo-grid">
              {currentProfile.photos.map((photo) => (
                <div key={photo.id} className="media-thumb-card">
                  <img src={photo.src} alt={photo.title} />
                  <span className="media-title">{photo.title}</span>
                  <span className="media-date">{photo.date}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="profile-module media-module">
            <h4>Memes & Image Posts</h4>
            <div className="meme-grid">
              {currentProfile.memes.map((meme) => (
                <div key={meme.id} className="meme-card">
                  <img src={meme.src} alt={meme.title} />
                  <div className="meme-meta">
                    <span className="media-title">{meme.title}</span>
                    <span>{meme.caption}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="profile-module">
            <h4>Recent Activity</h4>
            <ul className="module-list">
              <li>Updated profile song list</li>
              <li>Joined "Old Web Designers" group</li>
              <li>Uploaded 2 photos</li>
              <li>Posted 2 nerd memes, 1 troll meme, and 1 baby meme</li>
              <li>Left 3 wall comments</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="myface-footer">
        <button className="back-btn" onClick={() => onNavigate('portal')}>Back to Portal</button>
        <p>FaceLeak © 2007 Profit Dynamics International. Profile data is retained for quality and advertising purposes.</p>
      </div>
    </div>
  );
};

export default MyFacePage;
